import * as React from 'react';
export const sffcuSvg = React.forwardRef(function sffcuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#951432',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M11.21 24.47c4.43 2.1 14.34 1.46 14.34 1.46s-1.84-.7-4.28-1.77c3.97-3 8.14-10.53 8.14-10.53s-6.47 4.63-11.5 6.98c.93.54 1.93 1.9 2.38 3.1a64.62 64.62 0 0 1-6.92-3.55 6.54 6.54 0 0 1-2.16 4.3zm0 4.07s-.61-7.78 0-13.16a7.18 7.18 0 0 1-4.45.18c2.2-1.4 4.92-3.05 7.32-4.17a6.76 6.76 0 0 1-2.37-3.1 64.62 64.62 0 0 1 6.92 3.55 6.54 6.54 0 0 1 2.16-4.3C16.36 5.43 6.45 6.06 6.45 6.06s1.84.7 4.28 1.77c-3.97 3-8.14 10.53-8.14 10.53s1.55-1.1 3.71-2.51c.3 4.84 4.91 12.68 4.91 12.68zm9.58-11.92c.61-5.38 0-13.16 0-13.16s4.92 8.38 4.92 13.16c-1.23-.6-3.7-.6-4.92 0z',
      }),
    ),
  );
});
sffcuSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var sffcu = {
  category: 'brand',
  colorable: false,
  name: 'sffcu',
  svg: sffcuSvg,
};
